import TermsOfUse from "../components/TermsOfUse";

function TermsPage() {
  return <TermsOfUse />;
}

export default TermsPage;
